import { useEffect, useState } from 'react';
import { useAccountContext } from '../../context/account/Account.context';
import { useUserData } from '../../context';
import { fetchAccountInfo } from '../../api/accountInfo/accountInfo';
import { useUnicornApiContext } from '../../UnicornApi.context';

export const useAccountInfoData = () => {
  const { unicornApi } = useUnicornApiContext();
  const [accountInfoData, setAccountInfoData] = useState<
    undefined | { maxCustomers: number; numCustomers: number; maxUsers: number; iseNewBilling: boolean }
  >();

  useEffect(() => {
    if (unicornApi) {
      setAccountInfoData({
        iseNewBilling: unicornApi.data.account.newBillingSystem,
        maxCustomers: unicornApi.data.account.maxNumberOfCustomers,
        maxUsers: unicornApi.data.account.maxNumberOfUsers,
        numCustomers: unicornApi.data.account.currentNumberOfCustomers,
      });
      return;
    }

    void fetchAccountInfo().then((res) => {
      setAccountInfoData({
        maxCustomers: res.max_customers,
        numCustomers: res.num_customers,
        maxUsers: res.max_users,
        iseNewBilling: res.new_billing_system,
      });
    });
  }, [setAccountInfoData, unicornApi]);

  return accountInfoData;
};

export const useProductEnvModal = () => {
  const { userData: user } = useUserData();
  const isFreePlan = useAccountContext()?.planName === 'free';
  const accountInfoData = useAccountInfoData();

  return Boolean(user?.isMasterAdmin && isFreePlan && accountInfoData?.maxCustomers === 1);
};

export const useAddUserModal = (isOutOfUsers: boolean) => {
  const { userData: user } = useUserData();
  const isFreePlan = useAccountContext()?.planName === 'free';
  const accountInfoData = useAccountInfoData();

  return Boolean((user?.isMasterAdmin ?? user?.isAdmin) && isFreePlan && accountInfoData?.maxUsers === 3 && isOutOfUsers);
};
